<template>
	<div class="tag-manager" :class="tagManagerClass">
		<v-contextual-content v-if="editable || numberOfTags" v-on:toggled="state => managingTags = state">
			<template v-slot:trigger="{ toggle }">
				<ul class="tag-list" @click="toggle">
					<tag v-for="(tag, tagId) in tags" class="tag--disc" :key="tagId" :tag="tag"/>
				</ul>
				<button
					class="tag-manager__toggle" @click.prevent="toggle"
					v-html="editable ? 'Manage Tags' : 'View Tags'"/>
			</template>
			<h2 v-html="editable ? 'Manage Tags' : 'Tags Locked'"/>
			<dl>
				<div
					v-for="(tag, tagId) in tagList" class="tag-manager__tag flex-apart" :class="tagClass(tag)"
					:key="tagId"
					@click="toggleTag(tag)">
					<dt>
						<tag :tag="tag"/>
					</dt>
					<dd>
						<bool-icon :value="tagApplied(tag)" negativeText="Off" positiveText="On"/>
					</dd>
				</div>
			</dl>
		</v-contextual-content>
	</div>
</template>
<script>
import Tag from "./Tag";

export default {
	components: {
		Tag,
	},
	data() {
		return {
			managingTags: false,
		};
	},
	computed: {
		tagManagerClass() {
			return {
				"tag-manager--editable": this.editable,
				"tag-manager--locked": !this.editable,
				"tag-manager--empty": this.editable && this.numberOfAvailableTags && !this.numberOfSelectedTags,
				"tag-manager--managing": this.managingTags,
			};
		},
		editable() {
			return this.canEdit && this.numberOfAvailableTags > 0;
		},
		availableTags() {
			return this.$authed()?.service_provider?.managedTags || {};
		},
		numberOfAvailableTags() {
			return Object.keys(this.availableTags).length;
		},
		tagList() {
			return this.editable ? this.availableTags : this.tags;
		},
		numberOfTags() {
			return Object.keys(this.tagList).length;
		},
		numberOfSelectedTags() {
			return Object.keys(this.tags).length;
		},
	},
	props: {
		canEdit: {
			required: false,
			type: Boolean,
			default() {
				return false;
			}
		},
		tags: {
			required: true,
			type: Object,
			default() {
				return {};
			}
		},
	},
	methods: {
		maybeToggle(toggle) {
			if (this.editable) {
				toggle();
			}
		},
		tagClass(tag) {
			return {
				"tag-manager__tag--applied": this.tagApplied(tag),
			};
		},
		toggleTag(tag) {
			if (this.editable) {
				this.$emit("toggleTag", tag);
			}
		},
		tagApplied(tag) {
			return _.has(this.tags, tag.id);
		}
	},
};
</script>
